export default "__VITE_ASSET__D$NDPzds__"